import { YOO_FINDS_CDN } from "@/common";

export const BRAND_BANNER = `${YOO_FINDS_CDN}/pc/brand/banner.png`;
